export const Curves = ({ size = 40 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Frame 928903">
        <path
          id="Vector 593"
          d="M3.30434 15.8404L39.0751 25.4252C33.1133 23.8277 26.6825 37.8912 19.7271 36.0275C12.7717 34.1638 14.7311 18.9022 3.30434 15.8404Z"
          fill="url(#paint0_linear_3867_18131)"
        />
        <path
          id="Vector 592"
          d="M3.30384 15.8424L39.0746 25.4271C23.6733 21.3004 20.0755 32.7401 13.1201 30.8764C8.15195 29.5452 8.76881 17.3067 3.30384 15.8424Z"
          fill="url(#paint1_linear_3867_18131)"
        />
        <path
          id="Vector 594"
          d="M2.83737 15.715L39.5426 25.5502C23.739 21.3156 22.122 12.8613 14.9849 10.9489C9.88692 9.58288 6.21811 16.6209 2.83737 15.715Z"
          fill="url(#paint2_linear_3867_18131)"
        />
        <path
          id="Vector 591"
          d="M3.30425 15.8403L39.075 25.4251C28.145 22.4964 30.6682 5.13064 25.7001 3.79943C20.7319 2.46821 15.2278 19.0353 3.30425 15.8403Z"
          fill="url(#paint3_linear_3867_18131)"
          fillOpacity="0.86"
        />
        <path
          id="Vector 590"
          d="M39.5422 25.5493L2.83702 15.7142C18.6407 19.9488 24.2681 13.4356 31.4053 15.348C36.5032 16.714 36.1615 24.6435 39.5422 25.5493Z"
          fill="url(#paint4_linear_3867_18131)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3867_18131"
          x1="37.1017"
          y1="32.7897"
          x2="1.33101"
          y2="23.205"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E182" />
          <stop offset="1" stopColor="#005ECD" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3867_18131"
          x1="23.4041"
          y1="27.4301"
          x2="7.40138"
          y2="23.1422"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFD706" stopOpacity="0.84" />
          <stop offset="1" stopColor="#00B212" stopOpacity="0.83" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3867_18131"
          x1="17.3658"
          y1="15.586"
          x2="3.84285"
          y2="11.9625"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8E09" />
          <stop offset="1" stopColor="#DE0000" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3867_18131"
          x1="34.6792"
          y1="7.94222"
          x2="12.4367"
          y2="14.9339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B900D7" />
          <stop offset="1" stopColor="#FFD704" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3867_18131"
          x1="22.6781"
          y1="17.0087"
          x2="39.0988"
          y2="21.4086"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8E09" />
          <stop offset="1" stopColor="#0016DE" />
        </linearGradient>
      </defs>
    </svg>
  )
}
